import { render } from "./custom-date.vue?vue&type=template&id=6fb60d14"
import script from "./custom-date.vue?vue&type=script&lang=js"
export * from "./custom-date.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__